export const YEAR_OPTIONS = Array.from({ length: 100 }, (_, i) => (2022 - i).toString());

/**
 * @description Country code options (legacy - 기존 코드 호환용)
 */
export const COUNTRY_CODE_OPTIONS = [
  'Korea (+82)',
  'Vietnam (+84)',
  'China (+86)',
  'USA, Canada (+1)',
  'Germany (+49)',

  'Afghanistan (+93)',
  'Albania (+355)',
  'Algeria (+213)',
  'American Samoa (+1)',
  'Andorra (+376)',
  'Angola (+244)',
  'Anguilla (+1)',
  'Antigua and Barbuda (+1)',
  'Argentina (+54)',
  'Armenia (+374)',
  'Australia (+61)',
  'Austria (+43)',
  'Azerbaijan (+994)',
  'Bahamas (+1)',
  'Bahrain (+973)',
  'Bangladesh (+880)',
  'Barbados (+1)',
  'Belarus (+375)',
  'Belgium (+32)',
  'Belize (+501)',
  'Benin (+229)',
  'Bermuda (+1)',
  'Bhutan (+975)',
  'Bolivia (+591)',
  'Bosnia and Herzegovina (+387)',
  'Botswana (+267)',
  'Brazil (+55)',
  'Brunei (+673)',
  'Bulgaria (+359)',
  'Burkina Faso (+226)',
  'Burundi (+257)',
  'Cambodia (+855)',
  'Cameroon (+237)',
  'Canada (+1)',
  'Cape Verde (+238)',
  'Cayman Islands (+1)',
  'Central African Republic (+236)',
  'Chad (+235)',
  'Chile (+56)',
  'Colombia (+57)',
  'Comoros (+269)',
  'Congo (+242)',
  'Congo, Democratic Republic (+243)',
  'Costa Rica (+506)',
  'Croatia (+385)',
  'Cuba (+53)',
  'Cyprus (+357)',
  'Czech Republic (+420)',
  'Denmark (+45)',
  'Djibouti (+253)',
  'Dominica (+1)',
  'Dominican Republic (+1)',
  'Ecuador (+593)',
  'Egypt (+20)',
  'El Salvador (+503)',
  'Equatorial Guinea (+240)',
  'Eritrea (+291)',
  'Estonia (+372)',
  'Ethiopia (+251)',
  'Fiji (+679)',
  'Finland (+358)',
  'France (+33)',
  'French Guiana (+594)',
  'Gabon (+241)',
  'Gambia (+220)',
  'Georgia (+995)',
  'Ghana (+233)',
  'Greece (+30)',
  'Greenland (+299)',
  'Grenada (+1)',
  'Guatemala (+502)',
  'Guinea (+224)',
  'Guinea-Bissau (+245)',
  'Guyana (+592)',
  'Haiti (+509)',
  'Honduras (+504)',
  'Hong Kong (+852)',
  'Hungary (+36)',
  'Iceland (+354)',
  'India (+91)',
  'Indonesia (+62)',
  'Iran (+98)',
  'Iraq (+964)',
  'Ireland (+353)',
  'Israel (+972)',
  'Italy (+39)',
  'Jamaica (+1)',
  'Japan (+81)',
  'Jordan (+962)',
  'Kazakhstan (+7)',
  'Kenya (+254)',
  'Kiribati (+686)',
  'Kuwait (+965)',
  'Kyrgyzstan (+996)',
  'Laos (+856)',
  'Latvia (+371)',
  'Lebanon (+961)',
  'Lesotho (+266)',
  'Liberia (+231)',
  'Libya (+218)',
  'Liechtenstein (+423)',
  'Lithuania (+370)',
  'Luxembourg (+352)',
  'Macao (+853)',
  'Macedonia (+389)',
  'Madagascar (+261)',
  'Malawi (+265)',
  'Malaysia (+60)',
  'Maldives (+960)',
  'Mali (+223)',
  'Malta (+356)',
  'Marshall Islands (+692)',
  'Mauritania (+222)',
  'Mauritius (+230)',
  'Mexico (+52)',
  'Micronesia (+691)',
  'Moldova (+373)',
  'Monaco (+377)',
  'Mongolia (+976)',
  'Montenegro (+382)',
  'Morocco (+212)',
  'Mozambique (+258)',
  'Myanmar (+95)',
  'Namibia (+264)',
  'Nauru (+674)',
  'Nepal (+977)',
  'Netherlands (+31)',
  'New Zealand (+64)',
  'Nicaragua (+505)',
  'Niger (+227)',
  'Nigeria (+234)',
  'North Korea (+850)',
  'Norway (+47)',
  'Oman (+968)',
  'Pakistan (+92)',
  'Palau (+680)',
  'Palestine (+970)',
  'Panama (+507)',
  'Papua New Guinea (+675)',
  'Paraguay (+595)',
  'Peru (+51)',
  'Philippines (+63)',
  'Poland (+48)',
  'Portugal (+351)',
  'Qatar (+974)',
  'Romania (+40)',
  'Russia (+7)',
  'Rwanda (+250)',
  'Saint Kitts and Nevis (+1)',
  'Saint Lucia (+1)',
  'Saint Vincent and the Grenadines (+1)',
  'Samoa (+685)',
  'San Marino (+378)',
  'Sao Tome and Principe (+239)',
  'Saudi Arabia (+966)',
  'Senegal (+221)',
  'Serbia (+381)',
  'Seychelles (+248)',
  'Sierra Leone (+232)',
  'Singapore (+65)',
  'Slovakia (+421)',
  'Slovenia (+386)',
  'Solomon Islands (+677)',
  'Somalia (+252)',
  'South Africa (+27)',
  'South Sudan (+211)',
  'Spain (+34)',
  'Sri Lanka (+94)',
  'Sudan (+249)',
  'Suriname (+597)',
  'Swaziland (+268)',
  'Sweden (+46)',
  'Switzerland (+41)',
  'Syria (+963)',
  'Taiwan (+886)',
  'Tajikistan (+992)',
  'Tanzania (+255)',
  'Thailand (+66)',
  'Timor-Leste (+670)',
  'Togo (+228)',
  'Tonga (+676)',
  'Trinidad and Tobago (+1)',
  'Tunisia (+216)',
  'Turkey (+90)',
  'Turkmenistan (+993)',
  'Tuvalu (+688)',
  'Uganda (+256)',
  'Ukraine (+380)',
  'United Arab Emirates (+971)',
  'United Kingdom (+44)',
  'Uruguay (+598)',
  'Uzbekistan (+998)',
  'Vanuatu (+678)',
  'Venezuela (+58)',
  'Yemen (+967)',
  'Zambia (+260)',
  'Zimbabwe (+263)',
];

/**
 * @description Country code options with label and value
 * - label: UI에 표시될 텍스트 (예: 'Korea (+82)')
 * - value: 서버로 전송될 숫자 코드 (예: '82')
 */
export const COUNTRY_CODE_OPTIONS_V2 = [
  { label: 'Korea (+82)', value: '82' },
  { label: 'Vietnam (+84)', value: '84' },
  { label: 'China (+86)', value: '86' },
  { label: 'USA, Canada (+1)', value: '1' },
  { label: 'Germany (+49)', value: '49' },
  { label: 'Afghanistan (+93)', value: '93' },
  { label: 'Albania (+355)', value: '355' },
  { label: 'Algeria (+213)', value: '213' },
  { label: 'American Samoa (+1)', value: '1' },
  { label: 'Andorra (+376)', value: '376' },
  { label: 'Angola (+244)', value: '244' },
  { label: 'Anguilla (+1)', value: '1' },
  { label: 'Antigua and Barbuda (+1)', value: '1' },
  { label: 'Argentina (+54)', value: '54' },
  { label: 'Armenia (+374)', value: '374' },
  { label: 'Australia (+61)', value: '61' },
  { label: 'Austria (+43)', value: '43' },
  { label: 'Azerbaijan (+994)', value: '994' },
  { label: 'Bahamas (+1)', value: '1' },
  { label: 'Bahrain (+973)', value: '973' },
  { label: 'Bangladesh (+880)', value: '880' },
  { label: 'Barbados (+1)', value: '1' },
  { label: 'Belarus (+375)', value: '375' },
  { label: 'Belgium (+32)', value: '32' },
  { label: 'Belize (+501)', value: '501' },
  { label: 'Benin (+229)', value: '229' },
  { label: 'Bermuda (+1)', value: '1' },
  { label: 'Bhutan (+975)', value: '975' },
  { label: 'Bolivia (+591)', value: '591' },
  { label: 'Bosnia and Herzegovina (+387)', value: '387' },
  { label: 'Botswana (+267)', value: '267' },
  { label: 'Brazil (+55)', value: '55' },
  { label: 'Brunei (+673)', value: '673' },
  { label: 'Bulgaria (+359)', value: '359' },
  { label: 'Burkina Faso (+226)', value: '226' },
  { label: 'Burundi (+257)', value: '257' },
  { label: 'Cambodia (+855)', value: '855' },
  { label: 'Cameroon (+237)', value: '237' },
  { label: 'Canada (+1)', value: '1' },
  { label: 'Cape Verde (+238)', value: '238' },
  { label: 'Cayman Islands (+1)', value: '1' },
  { label: 'Central African Republic (+236)', value: '236' },
  { label: 'Chad (+235)', value: '235' },
  { label: 'Chile (+56)', value: '56' },
  { label: 'Colombia (+57)', value: '57' },
  { label: 'Comoros (+269)', value: '269' },
  { label: 'Congo (+242)', value: '242' },
  { label: 'Congo, Democratic Republic (+243)', value: '243' },
  { label: 'Costa Rica (+506)', value: '506' },
  { label: 'Croatia (+385)', value: '385' },
  { label: 'Cuba (+53)', value: '53' },
  { label: 'Cyprus (+357)', value: '357' },
  { label: 'Czech Republic (+420)', value: '420' },
  { label: 'Denmark (+45)', value: '45' },
  { label: 'Djibouti (+253)', value: '253' },
  { label: 'Dominica (+1)', value: '1' },
  { label: 'Dominican Republic (+1)', value: '1' },
  { label: 'Ecuador (+593)', value: '593' },
  { label: 'Egypt (+20)', value: '20' },
  { label: 'El Salvador (+503)', value: '503' },
  { label: 'Equatorial Guinea (+240)', value: '240' },
  { label: 'Eritrea (+291)', value: '291' },
  { label: 'Estonia (+372)', value: '372' },
  { label: 'Ethiopia (+251)', value: '251' },
  { label: 'Fiji (+679)', value: '679' },
  { label: 'Finland (+358)', value: '358' },
  { label: 'France (+33)', value: '33' },
  { label: 'French Guiana (+594)', value: '594' },
  { label: 'Gabon (+241)', value: '241' },
  { label: 'Gambia (+220)', value: '220' },
  { label: 'Georgia (+995)', value: '995' },
  { label: 'Ghana (+233)', value: '233' },
  { label: 'Greece (+30)', value: '30' },
  { label: 'Greenland (+299)', value: '299' },
  { label: 'Grenada (+1)', value: '1' },
  { label: 'Guatemala (+502)', value: '502' },
  { label: 'Guinea (+224)', value: '224' },
  { label: 'Guinea-Bissau (+245)', value: '245' },
  { label: 'Guyana (+592)', value: '592' },
  { label: 'Haiti (+509)', value: '509' },
  { label: 'Honduras (+504)', value: '504' },
  { label: 'Hong Kong (+852)', value: '852' },
  { label: 'Hungary (+36)', value: '36' },
  { label: 'Iceland (+354)', value: '354' },
  { label: 'India (+91)', value: '91' },
  { label: 'Indonesia (+62)', value: '62' },
  { label: 'Iran (+98)', value: '98' },
  { label: 'Iraq (+964)', value: '964' },
  { label: 'Ireland (+353)', value: '353' },
  { label: 'Israel (+972)', value: '972' },
  { label: 'Italy (+39)', value: '39' },
  { label: 'Jamaica (+1)', value: '1' },
  { label: 'Japan (+81)', value: '81' },
  { label: 'Jordan (+962)', value: '962' },
  { label: 'Kazakhstan (+7)', value: '7' },
  { label: 'Kenya (+254)', value: '254' },
  { label: 'Kiribati (+686)', value: '686' },
  { label: 'Kuwait (+965)', value: '965' },
  { label: 'Kyrgyzstan (+996)', value: '996' },
  { label: 'Laos (+856)', value: '856' },
  { label: 'Latvia (+371)', value: '371' },
  { label: 'Lebanon (+961)', value: '961' },
  { label: 'Lesotho (+266)', value: '266' },
  { label: 'Liberia (+231)', value: '231' },
  { label: 'Libya (+218)', value: '218' },
  { label: 'Liechtenstein (+423)', value: '423' },
  { label: 'Lithuania (+370)', value: '370' },
  { label: 'Luxembourg (+352)', value: '352' },
  { label: 'Macao (+853)', value: '853' },
  { label: 'Macedonia (+389)', value: '389' },
  { label: 'Madagascar (+261)', value: '261' },
  { label: 'Malawi (+265)', value: '265' },
  { label: 'Malaysia (+60)', value: '60' },
  { label: 'Maldives (+960)', value: '960' },
  { label: 'Mali (+223)', value: '223' },
  { label: 'Malta (+356)', value: '356' },
  { label: 'Marshall Islands (+692)', value: '692' },
  { label: 'Mauritania (+222)', value: '222' },
  { label: 'Mauritius (+230)', value: '230' },
  { label: 'Mexico (+52)', value: '52' },
  { label: 'Micronesia (+691)', value: '691' },
  { label: 'Moldova (+373)', value: '373' },
  { label: 'Monaco (+377)', value: '377' },
  { label: 'Mongolia (+976)', value: '976' },
  { label: 'Montenegro (+382)', value: '382' },
  { label: 'Morocco (+212)', value: '212' },
  { label: 'Mozambique (+258)', value: '258' },
  { label: 'Myanmar (+95)', value: '95' },
  { label: 'Namibia (+264)', value: '264' },
  { label: 'Nauru (+674)', value: '674' },
  { label: 'Nepal (+977)', value: '977' },
  { label: 'Netherlands (+31)', value: '31' },
  { label: 'New Zealand (+64)', value: '64' },
  { label: 'Nicaragua (+505)', value: '505' },
  { label: 'Niger (+227)', value: '227' },
  { label: 'Nigeria (+234)', value: '234' },
  { label: 'North Korea (+850)', value: '850' },
  { label: 'Norway (+47)', value: '47' },
  { label: 'Oman (+968)', value: '968' },
  { label: 'Pakistan (+92)', value: '92' },
  { label: 'Palau (+680)', value: '680' },
  { label: 'Palestine (+970)', value: '970' },
  { label: 'Panama (+507)', value: '507' },
  { label: 'Papua New Guinea (+675)', value: '675' },
  { label: 'Paraguay (+595)', value: '595' },
  { label: 'Peru (+51)', value: '51' },
  { label: 'Philippines (+63)', value: '63' },
  { label: 'Poland (+48)', value: '48' },
  { label: 'Portugal (+351)', value: '351' },
  { label: 'Qatar (+974)', value: '974' },
  { label: 'Romania (+40)', value: '40' },
  { label: 'Russia (+7)', value: '7' },
  { label: 'Rwanda (+250)', value: '250' },
  { label: 'Saint Kitts and Nevis (+1)', value: '1' },
  { label: 'Saint Lucia (+1)', value: '1' },
  { label: 'Saint Vincent and the Grenadines (+1)', value: '1' },
  { label: 'Samoa (+685)', value: '685' },
  { label: 'San Marino (+378)', value: '378' },
  { label: 'Sao Tome and Principe (+239)', value: '239' },
  { label: 'Saudi Arabia (+966)', value: '966' },
  { label: 'Senegal (+221)', value: '221' },
  { label: 'Serbia (+381)', value: '381' },
  { label: 'Seychelles (+248)', value: '248' },
  { label: 'Sierra Leone (+232)', value: '232' },
  { label: 'Singapore (+65)', value: '65' },
  { label: 'Slovakia (+421)', value: '421' },
  { label: 'Slovenia (+386)', value: '386' },
  { label: 'Solomon Islands (+677)', value: '677' },
  { label: 'Somalia (+252)', value: '252' },
  { label: 'South Africa (+27)', value: '27' },
  { label: 'South Sudan (+211)', value: '211' },
  { label: 'Spain (+34)', value: '34' },
  { label: 'Sri Lanka (+94)', value: '94' },
  { label: 'Sudan (+249)', value: '249' },
  { label: 'Suriname (+597)', value: '597' },
  { label: 'Swaziland (+268)', value: '268' },
  { label: 'Sweden (+46)', value: '46' },
  { label: 'Switzerland (+41)', value: '41' },
  { label: 'Syria (+963)', value: '963' },
  { label: 'Taiwan (+886)', value: '886' },
  { label: 'Tajikistan (+992)', value: '992' },
  { label: 'Tanzania (+255)', value: '255' },
  { label: 'Thailand (+66)', value: '66' },
  { label: 'Timor-Leste (+670)', value: '670' },
  { label: 'Togo (+228)', value: '228' },
  { label: 'Tonga (+676)', value: '676' },
  { label: 'Trinidad and Tobago (+1)', value: '1' },
  { label: 'Tunisia (+216)', value: '216' },
  { label: 'Turkey (+90)', value: '90' },
  { label: 'Turkmenistan (+993)', value: '993' },
  { label: 'Tuvalu (+688)', value: '688' },
  { label: 'Uganda (+256)', value: '256' },
  { label: 'Ukraine (+380)', value: '380' },
  { label: 'United Arab Emirates (+971)', value: '971' },
  { label: 'United Kingdom (+44)', value: '44' },
  { label: 'Uruguay (+598)', value: '598' },
  { label: 'Uzbekistan (+998)', value: '998' },
  { label: 'Vanuatu (+678)', value: '678' },
  { label: 'Venezuela (+58)', value: '58' },
  { label: 'Yemen (+967)', value: '967' },
  { label: 'Zambia (+260)', value: '260' },
  { label: 'Zimbabwe (+263)', value: '263' },
] as const;

/**
 * @description Nationality options
 */
export const NATIONALITY_OPTIONS = [
  'Korea, Republic of',
  'Vietnam',
  'China',
  'United States',
  'Germany',

  'Afghanistan',
  'Åland Islands',
  'Albania',
  'Algeria',
  'American Samoa',
  'Andorra',
  'Angola',
  'Anguilla',
  'Antarctica',
  'Antigua and Barbuda',
  'Argentina',
  'Armenia',
  'Aruba',
  'Australia',
  'Austria',
  'Azerbaijan',
  'Bahamas',
  'Bahrain',
  'Bangladesh',
  'Barbados',
  'Belarus',
  'Belgium',
  'Belize',
  'Benin',
  'Bermuda',
  'Bhutan',
  'Bolivia',
  'Bonaire, Sint Eustatius and Saba',
  'Bosnia and Herzegovina',
  'Botswana',
  'Bouvet Island',
  'Brazil',
  'British Indian Ocean Territory',
  'Brunei Darussalam',
  'Bulgaria',
  'Burkina Faso',
  'Burundi',
  'Cambodia',
  'Cameroon',
  'Canada',
  'Cape Verde',
  'Cayman Islands',
  'Central African Republic',
  'Chad',
  'Chile',
  'Christmas Island',
  'Cocos (Keeling) Islands',
  'Colombia',
  'Comoros',
  'Congo, Republic of the (Brazzaville)',
  'Congo, the Democratic Republic of the (Kinshasa)',
  'Cook Islands',
  'Costa Rica',
  "Côte d'Ivoire, Republic of",
  'Croatia',
  'Cuba',
  'Curaçao',
  'Cyprus',
  'Czech Republic',
  'Denmark',
  'Djibouti',
  'Dominica',
  'Dominican Republic',
  'Ecuador',
  'Egypt',
  'El Salvador',
  'Equatorial Guinea',
  'Eritrea',
  'Estonia',
  'Ethiopia',
  'Falkland Islands (Islas Malvinas)',
  'Faroe Islands',
  'Fiji',
  'Finland',
  'France',
  'French Guiana',
  'French Polynesia',
  'French Southern and Antarctic Lands',
  'Gabon',
  'Gambia, The',
  'Georgia',
  'Ghana',
  'Gibraltar',
  'Greece',
  'Greenland',
  'Grenada',
  'Guadeloupe',
  'Guam',
  'Guatemala',
  'Guernsey',
  'Guinea',
  'Guinea-Bissau',
  'Guyana',
  'Haiti',
  'Heard Island and McDonald Islands',
  'Holy See (Vatican City)',
  'Honduras',
  'Hong Kong',
  'Hungary',
  'Iceland',
  'India',
  'Indonesia',
  'Iran, Islamic Republic of',
  'Iraq',
  'Ireland',
  'Isle of Man',
  'Israel',
  'Italy',
  'Jamaica',
  'Japan',
  'Jersey',
  'Jordan',
  'Kazakhstan',
  'Kenya',
  'Kiribati',
  "Korea, Democratic People's Republic of",
  'Kosovo',
  'Kuwait',
  'Kyrgyzstan',
  'Laos',
  'Latvia',
  'Lebanon',
  'Lesotho',
  'Liberia',
  'Libya',
  'Liechtenstein',
  'Lithuania',
  'Luxembourg',
  'Macao',
  'Macedonia, Republic of',
  'Madagascar',
  'Malawi',
  'Malaysia',
  'Maldives',
  'Mali',
  'Malta',
  'Marshall Islands',
  'Martinique',
  'Mauritania',
  'Mauritius',
  'Mayotte',
  'Mexico',
  'Micronesia, Federated States of',
  'Moldova',
  'Monaco',
  'Mongolia',
  'Montenegro',
  'Montserrat',
  'Morocco',
  'Mozambique',
  'Myanmar',
  'Namibia',
  'Nauru',
  'Nepal',
  'Netherlands',
  'New Caledonia',
  'New Zealand',
  'Nicaragua',
  'Niger',
  'Nigeria',
  'Niue',
  'Norfolk Island',
  'Northern Mariana Islands',
  'Norway',
  'Oman',
  'Pakistan',
  'Palau',
  'Palestine',
  'Panama',
  'Papua New Guinea',
  'Paraguay',
  'Peru',
  'Philippines',
  'Pitcairn',
  'Poland',
  'Portugal',
  'Puerto Rico',
  'Qatar',
  'Réunion',
  'Romania',
  'Russian Federation',
  'Rwanda',
  'Saint Barthélemy',
  'Saint Helena, Ascension and Tristan da Cunha',
  'Saint Kitts and Nevis',
  'Saint Lucia',
  'Saint Martin',
  'Saint Pierre and Miquelon',
  'Saint Vincent and the Grenadines',
  'Samoa',
  'San Marino',
  'Sao Tome and Principe',
  'Saudi Arabia',
  'Senegal',
  'Serbia',
  'Seychelles',
  'Sierra Leone',
  'Singapore',
  'Sint Maarten (Dutch part)',
  'Slovakia',
  'Slovenia',
  'Solomon Islands',
  'Somalia',
  'South Africa',
  'South Georgia and South Sandwich Islands',
  'South Sudan',
  'Spain',
  'Sri Lanka',
  'Sudan',
  'Suriname',
  'Eswatini',
  'Sweden',
  'Switzerland',
  'Syrian Arab Republic',
  'Taiwan',
  'Tajikistan',
  'Tanzania, United Republic of',
  'Thailand',
  'Timor-Leste',
  'Togo',
  'Tokelau',
  'Tonga',
  'Trinidad and Tobago',
  'Tunisia',
  'Turkey',
  'Turkmenistan',
  'Turks and Caicos Islands',
  'Tuvalu',
  'Uganda',
  'Ukraine',
  'United Arab Emirates',
  'United Kingdom',
  'United States Minor Outlying Islands',
  'Uruguay',
  'Uzbekistan',
  'Vanuatu',
  'Venezuela, Bolivarian Republic of',
  'Virgin Islands, British',
  'Virgin Islands, U.S.',
  'Wallis and Futuna',
  'Western Sahara',
  'Yemen',
  'Zambia',
  'Zimbabwe',
] as const;

export const OCCUPATION_OPTIONS = [
  'Undergraduate Student',
  'Graduate Student',
  'Exchange Student',
  'Education/Academic Research',
  'IT/Software/Engineering',
  'Manufacture/Agriculture',
  'Arts/Design',
  'Finance/Banking',
  'Public Service/Government',
  'Healthcare/Medical Service',
  'Business/Sales',
  'Legal/Consulting',
  'Others',
];

export const VISA_INFO_OPTIONS = [
  'Diplomatic/Official(A-1,A-2)',
  'Visa Exempted(B)',
  'Journalism/Religious Affairs(C-1, D-5, D-6)',
  'Short Term Visit(C-2, C-3)',
  'Study(D-2)',
  'Trainee(D-3,D-4)',
  'Intra-Company Transfer(D-7)',
  'Professional(C-4, D-1, D-8, D-9, D-10, E-1, E-2, E-3, E-4, E-5, E-6, E-7)',
  'Non-Professional(E-8, E-9, E-10)',
  'Working Holiday(H-1)',
  'Work and Visit(H-2)',
  'Familiy Visitor/Dependent Family(F-1, F-2, F-3)',
  'Overseas Korean(F-4)',
  'Permanent Residence(F-5)',
  'Marrige Migrant(F-6)',
  'Others(G-1)',
];

/**
 * @description Preferred property area options with label and value
 * - label: UI에 표시될 텍스트
 * - value: 서버로 전송될 값
 */
export const PREFERRED_PROPERTY_AREA_OPTIONS = [
  { label: 'Seoul national univ station', value: 'SNU' },
  { label: 'Daehak-dong(Nokdu) & Sillim', value: 'DAEHAK_DONG' },
  { label: 'Gangnam', value: 'GANGNAM' },
  { label: 'Shinchon', value: 'SINCHON' },
  { label: 'Near Sungkyunkwan univ', value: 'SUNGKYUNKWAN' },
  { label: 'Near Korea Univ, Kyunghee Univ, HUFS', value: 'HUFS' },
  { label: 'Others', value: 'OTHERS' },
] as const;

/**
 * @description Room type options with label and value
 * - label: UI에 표시될 텍스트
 * - value: 서버로 전송될 값
 */
export const PREFERRED_ROOM_TYPE_OPTIONS = [
  { label: 'Studio', value: 'STUDIO' },
  { label: 'Sharehouse', value: 'SHARE_HOUSE' },
  { label: 'Officetel', value: 'OFFICETEL' },
  { label: 'Others', value: 'OTHERS' },
] as const;

/**
 * //TODO: 추후 신촌 추가 예정
 * @link https://www.notion.so/28dc00e5608680198d82e7b48dd4ad25?v=1ddc00e5608681b1b924000ce5d1111a
 */
export const UNIV_LIST = [
  {
    id: 'SNU',
    title: 'Seoul National\nUniversity',
    url: '?originalWhere=SNU+University&whereType=UNIVERSITY&whereValue=SNU&source=univ_card',
    banner: '/images/optimized/univ/banner/snu1.webp',
    card: '/images/optimized/univ/card/snu.webp',
    link: 'https://buttercup-coral-e9a.notion.site/SNU-Local-Info-8e2dd6a65483456bb3afe31a3b7f246f?pvs=4',
  },
  {
    id: 'SSU',
    title: 'Soongsil\nUniversity',
    url: '?originalWhere=SSU+University&whereType=UNIVERSITY&whereValue=SSU&source=univ_card',
    banner: '/images/optimized/univ/banner/ssu1.webp',
    card: '/images/optimized/univ/card/ssu.webp',
    link: 'https://buttercup-coral-e9a.notion.site/Soongsil-Uni-Local-Info-a5ea3235b58e45f89eca12c25f6abe44?pvs=4',
  },
  {
    id: 'CAU',
    title: 'Chung-Ang\nUniversity',
    url: '?originalWhere=CAU+University&whereType=UNIVERSITY&whereValue=CAU&source=univ_card',
    banner: '/images/optimized/univ/banner/cau1.webp',
    card: '/images/optimized/univ/card/cau.webp',
    link: 'https://buttercup-coral-e9a.notion.site/CAU-Local-Info-c8e404a7b7774fe098a47ad0cd13fad1?pvs=4',
  },
  {
    id: 'GANGNAM',
    title: 'Gangnam',
    url: '?originalWhere=Gangnam-gu%2CSeoul&whereType=ADDRESS&whereValue=11680&source=district_card',
    banner: '/images/optimized/univ/card/gangnam.jpg',
    card: '/images/optimized/univ/card/gangnam.jpg',
    link: '',
  },

  {
    id: 'SKKU',
    title: 'Sungkyunkwan\nUniversity',
    url: '?originalWhere=SKKU+University&whereType=UNIVERSITY&whereValue=SKKU&source=univ_card',
    banner: '/images/optimized/univ/banner/skku1.webp',
    card: '/images/optimized/univ/card/skku.webp',
    link: 'https://buttercup-coral-e9a.notion.site/SKKU-Local-Info-9e7a7b270ec245138a327c76c91e6c83?pvs=4',
  },
  {
    id: 'KHU',
    title: 'KyungHee\nUniversity',
    url: '?originalWhere=KHU+University&whereType=UNIVERSITY&whereValue=KHU&source=univ_card',
    banner: '/images/optimized/univ/banner/kyunghee1.webp',
    card: '/images/optimized/univ/card/kyunghee.webp',
    link: 'https://buttercup-coral-e9a.notion.site/KyungHee-Univ-Local-Info-220c00e560868016b903c3d1989e08e6?source=copy_link',
  },

  {
    id: 'KOREA',
    title: 'Korea\nUniversity',
    url: '?originalWhere=KOREA+University&whereType=UNIVERSITY&whereValue=KOREA&source=univ_card',
    banner: '/images/optimized/univ/banner/korea1.webp',
    card: '/images/optimized/univ/card/korea.webp',
    link: 'https://buttercup-coral-e9a.notion.site/Korea-Uni-Local-Info-f1c54a884d834c0e9e9e08e0e23c9866?pvs=4',
  },
  {
    id: 'HUFS',
    title: 'HUFS',
    url: '?originalWhere=HUFS&whereType=UNIVERSITY&whereValue=HUFS&source=univ_card',
    banner: '/images/optimized/univ/banner/hufs1.webp',
    card: '/images/optimized/univ/card/hufs.webp',
    link: 'https://buttercup-coral-e9a.notion.site/HUFS-Local-Info-222c00e560868019958ae97aafd5c405?source=copy_link',
  },
  {
    id: 'KONKUK',
    title: 'Konkuk\nUniversity',
    url: '?originalWhere=KONKUK+University&whereType=UNIVERSITY&whereValue=KONKUK&source=univ_card',
    banner: '/images/optimized/univ/banner/konkuk1.webp',
    card: '/images/optimized/univ/card/konkuk.webp',
    link: '',
  },
  {
    id: 'DONGGUK',
    title: 'Dongguk\nUniversity',
    url: '?originalWhere=DONGGUK+University&whereType=UNIVERSITY&whereValue=DONGGUK&source=univ_card',
    banner: '/images/optimized/univ/banner/dongguk1.webp',
    card: '/images/optimized/univ/card/dongguk.webp',
    link: 'https://buttercup-coral-e9a.notion.site/Dongguk-Uni-Local-Info-1dfc00e560868028b8cef114508cc1cb',
  },
  {
    id: 'EWHA',
    title: 'Ewha\nUniversity',
    url: '?originalWhere=IHWA+University&whereType=UNIVERSITY&whereValue=EWHA&source=univ_card',
    banner: '/images/optimized/univ/banner/ewha1.webp',
    card: '/images/optimized/univ/card/ewha.webp',
    link: 'https://buttercup-coral-e9a.notion.site/Ehwa-W-Uni-Local-Info-1d9c00e560868068b9d8c3945c8af044',
  },
];

/**
 * @description Gender options
 */
export const GENDER_OPTIONS = ['MALE', 'FEMALE'] as const;

export const MONTH_OPTIONS = ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEP', 'OCT', 'NOV', 'DEC'];

export const DAY_OPTIONS_BY_MONTH_AND_YEAR = (month: string, year: string) => {
  const yearNum = parseInt(year) ?? 2000;
  switch (month) {
    case 'JAN':
    case 'MAR':
    case 'MAY':
    case 'JUL':
    case 'AUG':
    case 'OCT':
    case 'DEC':
      return Array.from({ length: 31 }, (_, i) => (i < 9 ? `0${i + 1}` : (i + 1).toString()));
    case 'APR':
    case 'JUN':
    case 'SEP':
    case 'NOV':
      return Array.from({ length: 30 }, (_, i) => (i < 9 ? `0${i + 1}` : (i + 1).toString()));
    case 'FEB':
      if ((yearNum % 4 === 0 && yearNum % 100 !== 0) || yearNum % 400 === 0) {
        return Array.from({ length: 29 }, (_, i) => (i < 9 ? `0${i + 1}` : (i + 1).toString()));
      }
      return Array.from({ length: 28 }, (_, i) => (i < 9 ? `0${i + 1}` : (i + 1).toString()));
    default:
      return [];
  }
};

/**
 * @description Server type options
 */
export const SERVER_TYPE_OPTIONS = ['LOCAL', 'TEST', 'PRODUCTION'] as const;

/**
 * @description Order type options
 */
export const ORDER_TYPE_OPTIONS = ['CARD_REGISTRATION_ORDER', 'PROVISIONAL_CONTRACT_ORDER', 'REQUEST_A_ROOM'] as const;

/**
 * @description Payment type options
 */
export const PAYMENT_TYPE_OPTIONS = ['MONTHLY', 'LUMP_SUM'] as const;

/**
 * @description Card kind options with label and value
 */
export const CARD_KIND_OPTIONS = [
  { label: 'Mastercard', value: 'MASTERCARD' },
  { label: 'Visa', value: 'VISA' },
] as const;

/**
 * @description Review service options
 */
export const REVIEW_SERVICE_OPTIONS = [
  { id: 'HOUSE_BOOKING', label: 'Housing Booking' },
  { id: 'MEMBERSHIP', label: 'Membership' },
  { id: 'CHECKMATE_PLUS', label: 'Checkmate+' },
  { id: 'CHECK_WITH_YOU', label: 'Check With You' },
  { id: 'SIGNING_ACCOMPANIMENT', label: 'Contract Signing Accompaniment' },
  { id: 'REQUEST_A_ROOM', label: 'Request a Room List that Meets Your Criteria' },
] as const;

export const OCCUPATION_OPTIONS_V2 = [
  { id: 'UNDERGRADUATE', label: 'Undergraduate Student' },
  { id: 'GRADUATE', label: 'Graduate Student' },
  { id: 'EXCHANGE', label: 'Exchange Student' },
  { id: 'EDUCATION', label: 'Education/Academic Research' },
  { id: 'IT_SOFTWARE_ENGINEERING', label: 'IT/Software/Engineering' },
  { id: 'MANUFACTURE_AGRICULTURE', label: 'Manufacture/Agriculture' },
  { id: 'ARTS_DESIGN', label: 'Arts/Design' },
  { id: 'FINANCE_BANKING', label: 'Finance/Banking' },
  { id: 'PUBLIC_SERVICE', label: 'Public Service/Government' },
  { id: 'HEALTHCARE_MEDICAL', label: 'Healthcare/Medical Service' },
  { id: 'BUSINESS_SALES', label: 'Business/Sales' },
  { id: 'LEGAL_CONSULTING', label: 'Legal/Consulting' },
  { id: 'OTHERS', label: 'Others' },
] as const;
